import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  listContainer: {
    p: ['0', '0', '0', '24px', '40px']
  },
  column: (col: number) => ({
    gridColumn: `span ${col}`
  }),
  filler: {
    margin: '1px',
    flex: 1,
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`
  },
  filtersToSelectContainer: {
    alignItems: 'center',
    minHeight: '61px',
    display: 'grid',
    padding: ['0 16px 0 16px', '0 16px 0 16px', '0 0px 0 24px', 0],
    mb: '4px'
  },
  filtersSelectedContainer: {
    display: 'grid',
    padding: ['0 16px 0 16px', '0 16px 0 16px', 0]
  },
  sortElements: {
    display: 'flex',
    flexDirection: 'row',
    height: '53px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    'button > span': {
      bottom: 0
    }
  },
  buttonCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  seeMoreButton: {
    height: '36px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.rawColors.darkGrey700}`,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.h5,
    letterSpacing: theme.letterSpacings.caps,
    color: theme.rawColors.darkGrey700,
    backgroundColor: 'transparent',
    ...reusables.mainTransition('color,border-color,background-color', 'cubic-bezier(0, 0, 0.6, 1)', '.5s'),
    '&:hover': {
      color: theme.rawColors.neutralWhite,
      backgroundColor: theme.rawColors.neutralBlack
    },
    '&:active': {
      color: theme.rawColors.darkGrey700,
      backgroundColor: 'transparent'
    },
    span: {
      padding: '0 24px'
    }
  },
  filterButtonText: {
    transform: 'translateY(4px)'
  },
  progressLineSize: {
    maxWidth: '600px',
    width: ['91.4666667vw', '91.4666667vw', '65.0510204vw', '65.0510204vw', '100%'],
    margin: '0 auto'
  },
  productList: {
    gridGap: '4px'
  },
  bottomRow: {
    mb: '60px'
  },
  leftFilterColumn: {
    gridColumn: 'span 16'
  },
  rightFilterColumn: {
    gridColumn: 'span 8',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  filterButton: {
    transform: 'translateY(4px)',
    mr: '10px',
    letterSpacing: '0'
  },
  divider: {
    gridColumn: '1/-1',
    height: '1px',
    background: theme.rawColors.lightGrey300
  },
  sortSelectWrapper: {
    display: ['none', 'inline-flex']
  }
};